import React, { useState } from 'react';
import styled from '@xstyled/styled-components';
import { t } from 'ttag';
import Icon from '~/assets/icons/close.svg';

const CloseButton = styled.buttonBox`
  position: absolute;
  top: 1px;
  right: 3px;
  width: 24px;
  height: 24px;
  color: ${p => p.theme.colors.black};
  background: transparent;
`;

const InternetOffWrapper = styled.div<{ isPopupVisible: boolean }>`
  ${p => !p.isPopupVisible && 'display: none'};
  position: absolute;
  top: 20px;
  z-index: 1000;
  text-align: center;
  color: red;
  padding: 20px 30px;
  border-radius: 10px;
  background: ${p => p.theme.colors.white};
  font-size: 18px;
  left: 21%;
`;

export const InternetOff = ({
  isNetworkConnectionSlow
}: {
  isNetworkConnectionSlow?: boolean;
}) => {
  const [isPopupVisible, setIsPopupVisible] = useState(true);

  return (
    <InternetOffWrapper
      aria-modal={isPopupVisible}
      isPopupVisible={isPopupVisible}
    >
      {isNetworkConnectionSlow
        ? t`Your internet connection is slow. Please check your internet connection.`
        : t`Your device is offline. Please check your internet connection.`}
      <CloseButton
        autoFocus
        tabIndex={0}
        title={t`Close`}
        onClick={() => setIsPopupVisible(false)}
      >
        <Icon aria-label={t`Close`} />
      </CloseButton>
    </InternetOffWrapper>
  );
};
